//アプリで表示する再入荷表示の言語切り替え

window.addEventListener('load', function() {
  setTimeout(() => {
    var ele = document.getElementById('BIS_trigger');
    ele.textContent = "NOTIFY ME WHEN AVAILABLE";
  },
  500)
});